import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  ScheduleDetailPage,
  schedulePageSearchSchema,
  scheduleQueryOptions,
} from '@/features/schedules';

/** `?tab=`, the pool's list state, `?run=<runId>` (the bell links here) and `?preview=1`. */
export const Route = createFileRoute('/_authed/_active/org/schedules/$scheduleId')({
  staticData: { tours: ['schedules.detail'] },
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    schedulePageSearchSchema.parse(search),
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'products.read');
  },
  loader: async ({ context, params }) => {
    const schedule = await context.queryClient.query({
      ...scheduleQueryOptions(params.scheduleId),
      staleTime: 'static',
    });
    return { crumb: schedule.name };
  },
  component: ScheduleDetailPage,
});
